/**
 * Stripe publishable keys for the browser only (pk_*).
 * Never use sk_* secret keys in React — they must stay on the backend.
 *
 * CRA only inlines process.env.REACT_APP_* when accessed directly (not via env[key]).
 */

function sanitizePublishableKey(
  value: string | undefined,
  label: string,
): string | null {
  const key = value?.trim();
  if (!key) return null;

  if (key.startsWith("sk_")) {
    console.error(
      `[Stripe] ${label} is a secret key (sk_*). Use the matching publishable key (pk_*) instead.`,
    );
    return null;
  }

  if (!key.startsWith("pk_")) {
    console.error(`[Stripe] ${label} is not a valid publishable key (expected pk_*).`);
    return null;
  }

  return key;
}

/**
 * Glossa Pay — business onboarding + platform subscription billing.
 * Must match backend GLOSSA_PAY_STRIPE_KEY / GLOSSA_PAY_STRIPE_SECRET.
 */
export function getGlossaPayPublishableKey(): string | null {
  return (
    sanitizePublishableKey(
      process.env.REACT_APP_GLOSSA_PAY_STRIPE_PUBLISHABLE_KEY ??
        process.env.REACT_APP_GLOSSA_PAY_STRIPE_KEY,
      "REACT_APP_GLOSSA_PAY_STRIPE_PUBLISHABLE_KEY",
    ) ?? null
  );
}

/**
 * Default Stripe.js key for signup and other in-app billing flows.
 * Must match backend STRIPE_KEY / STRIPE_SECRET (or PaymentGatewayCredentials).
 */
export function getStripePublishableKey(): string | null {
  return (
    sanitizePublishableKey(
      process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
      "REACT_APP_STRIPE_PUBLISHABLE_KEY",
    ) ?? null
  );
}
